/**
 * Importing and exporting all views
 *
 * @author Daniel Kvistgaard <dkvistgaard@vertic.com>
 */

import HubSpot from './views/hubspot';
import GTM from './views/google-tag-manager';

import BtnToggleContent from './views/btn-toggle-content';
import FormValidation from './views/form-validation';

import Navigation from './views/navigation';

import Hero from './views/hero';
import Tabs from './views/tabs';
import DownloadGrid from './views/download-grid';
import ArticleVideo from './views/article-video';
import HotspotImage from './views/hotspot-image';
import InteractiveHero from './views/interactive-hero';
import BeforeAfter from './views/before-after';
import Products from './views/products';
import M10Packages from './views/m10Packages';

export default [
	HubSpot,
	GTM,

	BtnToggleContent,
	FormValidation,
	Navigation,

	Hero,
	Tabs,
	DownloadGrid,
	ArticleVideo,
	HotspotImage,
	InteractiveHero,
	BeforeAfter,
	Products,
	M10Packages
];
